/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            twitter
            blog
          }
        }
      }
    }
  `)

  // Set these values by editing "siteMetadata" in gatsby-config.js
  const author = data.site.siteMetadata?.author
  const social = data.site.siteMetadata?.social

  return (
    <div className="bio">
      <StaticImage
        className="bio-avatar"
        layout="fixed"
        formats={["auto", "webp", "avif"]}
        src="../images/profile-pic.jpg"
        width={50}
        height={50}
        quality={95}
        alt="Profile picture"
      />
      {author?.name && (
        <p>
          By{` `}
          <a
            href="https://einverne.info"
            target="_blank"
            rel="noopener"
          >
            <strong>{author.name}</strong>
          </a>{` `}
          {author?.summary || null}
          {` `}
            如果想了解更多，可以关注我的 
          <a href={`https://twitter.com/${social?.twitter || ``}`}>
            Twitter </a> 或者关注我的<a href={`${social?.blog || ``}`}>博客</a>。
        </p>
      )}
    </div>
  )
}

export default Bio
